export const citys =
    [
        {
            "children": [{"value": "济南市", "label": "济南市"}, {"value": "青岛市", "label": "青岛市"}, {
                "value": "淄博市",
                "label": "淄博市"
            }, {"value": "枣庄市", "label": "枣庄市"}, {"value": "东营市", "label": "东营市"}, {
                "value": "烟台市",
                "label": "烟台市"
            }, {"value": "潍坊市", "label": "潍坊市"}, {"value": "济宁市", "label": "济宁市"}, {
                "value": "泰安市",
                "label": "泰安市"
            }, {"value": "威海市", "label": "威海市"}, {"value": "日照市", "label": "日照市"}, {
                "value": "莱芜市",
                "label": "莱芜市"
            }, {"value": "临沂市", "label": "临沂市"}, {"value": "德州市", "label": "德州市"}, {
                "value": "聊城市",
                "label": "聊城市"
            }, {"value": "滨州市", "label": "滨州市"}, {"value": "菏泽市", "label": "菏泽市"}], "value": "山东省", "label": "山东省"
        },
        {
            "children": [{"value": "合肥市", "label": "合肥市"}, {"value": "芜湖市", "label": "芜湖市"}, {
                "value": "蚌埠市",
                "label": "蚌埠市"
            }, {"value": "淮南市", "label": "淮南市"}, {"value": "马鞍山市", "label": "马鞍山市"}, {
                "value": "淮北市",
                "label": "淮北市"
            }, {"value": "铜陵市", "label": "铜陵市"}, {"value": "安庆市", "label": "安庆市"}, {
                "value": "黄山市",
                "label": "黄山市"
            }, {"value": "滁州市", "label": "滁州市"}, {"value": "阜阳市", "label": "阜阳市"}, {
                "value": "宿州市",
                "label": "宿州市"
            }, {"value": "巢湖市", "label": "巢湖市"}, {"value": "六安市", "label": "六安市"}, {
                "value": "亳州市",
                "label": "亳州市"
            }, {"value": "池州市", "label": "池州市"}, {"value": "宣城市", "label": "宣城市"}], "value": "安徽省", "label": "安徽省"
        },
        {
            "children": [{"value": "太原市", "label": "太原市"}, {"value": "大同市", "label": "大同市"}, {
                "value": "阳泉市",
                "label": "阳泉市"
            }, {"value": "长治市", "label": "长治市"}, {"value": "晋城市", "label": "晋城市"}, {
                "value": "朔州市",
                "label": "朔州市"
            }, {"value": "晋中市", "label": "晋中市"}, {"value": "运城市", "label": "运城市"}, {
                "value": "忻州市",
                "label": "忻州市"
            }, {"value": "临汾市", "label": "临汾市"}, {"value": "吕梁市", "label": "吕梁市"}], "value": "山西省", "label": "山西省"
        },
        {
            "children": [{"value": "昆明市", "label": "昆明市"}, {"value": "曲靖市", "label": "曲靖市"}, {
                "value": "玉溪市",
                "label": "玉溪市"
            }, {"value": "保山市", "label": "保山市"}, {"value": "昭通市", "label": "昭通市"}, {
                "value": "丽江市",
                "label": "丽江市"
            }, {"value": "思茅市", "label": "思茅市"}, {"value": "临沧市", "label": "临沧市"}, {
                "value": "楚雄彝族自治州",
                "label": "楚雄彝族自治州"
            }, {"value": "红河哈尼族彝族自治州", "label": "红河哈尼族彝族自治州"}, {
                "value": "文山壮族苗族自治州",
                "label": "文山壮族苗族自治州"
            }, {"value": "西双版纳傣族自治州", "label": "西双版纳傣族自治州"}, {
                "value": "大理白族自治州",
                "label": "大理白族自治州"
            }, {"value": "德宏傣族景颇族自治州", "label": "德宏傣族景颇族自治州"}, {
                "value": "怒江傈僳族自治州",
                "label": "怒江傈僳族自治州"
            }, {"value": "迪庆藏族自治州", "label": "迪庆藏族自治州"}], "value": "云南省", "label": "云南省"
        },
        {
            "children": [{"value": "南宁市", "label": "南宁市"}, {"value": "柳州市", "label": "柳州市"}, {
                "value": "桂林市",
                "label": "桂林市"
            }, {"value": "梧州市", "label": "梧州市"}, {"value": "北海市", "label": "北海市"}, {
                "value": "防城港市",
                "label": "防城港市"
            }, {"value": "钦州市", "label": "钦州市"}, {"value": "贵港市", "label": "贵港市"}, {
                "value": "玉林市",
                "label": "玉林市"
            }, {"value": "百色市", "label": "百色市"}, {"value": "贺州市", "label": "贺州市"}, {
                "value": "河池市",
                "label": "河池市"
            }, {"value": "来宾市", "label": "来宾市"}, {"value": "崇左市", "label": "崇左市"}],
            "value": "广西壮族自治区",
            "label": "广西壮族自治区"
        },
        {"children": [{"value": "天津市", "label": "天津市"}], "value": "天津", "label": "天津"},
        {"children": [{"value": "北京市", "label": "北京市"}], "value": "北京", "label": "北京"},
        {
            "children": [{"value": "成都市", "label": "成都市"}, {"value": "自贡市", "label": "自贡市"}, {
                "value": "攀枝花市",
                "label": "攀枝花市"
            }, {"value": "泸州市", "label": "泸州市"}, {"value": "德阳市", "label": "德阳市"}, {
                "value": "绵阳市",
                "label": "绵阳市"
            }, {"value": "广元市", "label": "广元市"}, {"value": "遂宁市", "label": "遂宁市"}, {
                "value": "内江市",
                "label": "内江市"
            }, {"value": "乐山市", "label": "乐山市"}, {"value": "南充市", "label": "南充市"}, {
                "value": "眉山市",
                "label": "眉山市"
            }, {"value": "宜宾市", "label": "宜宾市"}, {"value": "广安市", "label": "广安市"}, {
                "value": "达州市",
                "label": "达州市"
            }, {"value": "雅安市", "label": "雅安市"}, {"value": "巴中市", "label": "巴中市"}, {
                "value": "资阳市",
                "label": "资阳市"
            }, {"value": "阿坝藏族羌族自治州", "label": "阿坝藏族羌族自治州"}, {
                "value": "甘孜藏族自治州",
                "label": "甘孜藏族自治州"
            }, {"value": "凉山彝族自治州", "label": "凉山彝族自治州"}], "value": "四川省", "label": "四川省"
        },
        {
            "children": [{"value": "呼和浩特市", "label": "呼和浩特市"}, {"value": "包头市", "label": "包头市"}, {
                "value": "乌海市",
                "label": "乌海市"
            }, {"value": "赤峰市", "label": "赤峰市"}, {"value": "通辽市", "label": "通辽市"}, {
                "value": "鄂尔多斯市",
                "label": "鄂尔多斯市"
            }, {"value": "呼伦贝尔市", "label": "呼伦贝尔市"}, {"value": "巴彦淖尔市", "label": "巴彦淖尔市"}, {
                "value": "乌兰察布市",
                "label": "乌兰察布市"
            }, {"value": "兴安盟", "label": "兴安盟"}, {"value": "锡林郭勒盟", "label": "锡林郭勒盟"}, {
                "value": "阿拉善盟",
                "label": "阿拉善盟"
            }], "value": "内蒙古自治区", "label": "内蒙古自治区"
        },
        {
            "children": [{"value": "台北市", "label": "台北市"}, {"value": "高雄市", "label": "高雄市"}, {
                "value": "基隆市",
                "label": "基隆市"
            }, {"value": "台中市", "label": "台中市"}, {"value": "台南市", "label": "台南市"}, {
                "value": "新竹市",
                "label": "新竹市"
            }, {"value": "嘉义市", "label": "嘉义市"}, {"value": "台北县", "label": "台北县"}, {
                "value": "宜兰县",
                "label": "宜兰县"
            }, {"value": "桃园县", "label": "桃园县"}, {"value": "新竹县", "label": "新竹县"}, {
                "value": "苗栗县",
                "label": "苗栗县"
            }, {"value": "台中县", "label": "台中县"}, {"value": "彰化县", "label": "彰化县"}, {
                "value": "南投县",
                "label": "南投县"
            }, {"value": "云林县", "label": "云林县"}, {"value": "嘉义县", "label": "嘉义县"}, {
                "value": "台南县",
                "label": "台南县"
            }, {"value": "高雄县", "label": "高雄县"}, {"value": "屏东县", "label": "屏东县"}, {
                "value": "澎湖县",
                "label": "澎湖县"
            }, {"value": "台东县", "label": "台东县"}, {"value": "花莲县", "label": "花莲县"}], "value": "台湾省", "label": "台湾省"
        },
        {
            "children": [{"value": "南京市", "label": "南京市"}, {"value": "无锡市", "label": "无锡市"}, {
                "value": "徐州市",
                "label": "徐州市"
            }, {"value": "常州市", "label": "常州市"}, {"value": "苏州市", "label": "苏州市"}, {
                "value": "南通市",
                "label": "南通市"
            }, {"value": "连云港市", "label": "连云港市"}, {"value": "淮安市", "label": "淮安市"}, {
                "value": "盐城市",
                "label": "盐城市"
            }, {"value": "扬州市", "label": "扬州市"}, {"value": "镇江市", "label": "镇江市"}, {
                "value": "泰州市",
                "label": "泰州市"
            }, {"value": "宿迁市", "label": "宿迁市"}], "value": "江苏省", "label": "江苏省"
        },
        {
            "children": [{"value": "长沙市", "label": "长沙市"}, {"value": "株洲市", "label": "株洲市"}, {
                "value": "湘潭市",
                "label": "湘潭市"
            }, {"value": "衡阳市", "label": "衡阳市"}, {"value": "邵阳市", "label": "邵阳市"}, {
                "value": "岳阳市",
                "label": "岳阳市"
            }, {"value": "常德市", "label": "常德市"}, {"value": "张家界市", "label": "张家界市"}, {
                "value": "益阳市",
                "label": "益阳市"
            }, {"value": "郴州市", "label": "郴州市"}, {"value": "永州市", "label": "永州市"}, {
                "value": "怀化市",
                "label": "怀化市"
            }, {"value": "娄底市", "label": "娄底市"}, {"value": "湘西土家族苗族自治州", "label": "湘西土家族苗族自治州"}],
            "value": "湖南省",
            "label": "湖南省"
        },
        {
            "children": [{"value": "长春市", "label": "长春市"}, {"value": "吉林市", "label": "吉林市"}, {
                "value": "四平市",
                "label": "四平市"
            }, {"value": "辽源市", "label": "辽源市"}, {"value": "通化市", "label": "通化市"}, {
                "value": "白山市",
                "label": "白山市"
            }, {"value": "松原市", "label": "松原市"}, {"value": "白城市", "label": "白城市"}, {
                "value": "延边朝鲜族自治州",
                "label": "延边朝鲜族自治州"
            }], "value": "吉林省", "label": "吉林省"
        },
        {
            "children": [{"value": "哈尔滨市", "label": "哈尔滨市"}, {"value": "齐齐哈尔市", "label": "齐齐哈尔市"}, {
                "value": "鸡西市",
                "label": "鸡西市"
            }, {"value": "鹤岗市", "label": "鹤岗市"}, {"value": "双鸭山市", "label": "双鸭山市"}, {
                "value": "大庆市",
                "label": "大庆市"
            }, {"value": "伊春市", "label": "伊春市"}, {"value": "佳木斯市", "label": "佳木斯市"}, {
                "value": "七台河市",
                "label": "七台河市"
            }, {"value": "牡丹江市", "label": "牡丹江市"}, {"value": "黑河市", "label": "黑河市"}, {"value": "讷河市", "label": "讷河市"},{
                "value": "绥化市",
                "label": "绥化市"
            }, {"value": "大兴安岭地区", "label": "大兴安岭地区"}], "value": "黑龙江省", "label": "黑龙江省"
        },
        {
            "children": [{"value": "贵阳市", "label": "贵阳市"}, {"value": "六盘水市", "label": "六盘水市"}, {
                "value": "遵义市",
                "label": "遵义市"
            }, {"value": "安顺市", "label": "安顺市"}, {"value": "铜仁地区", "label": "铜仁地区"}, {
                "value": "黔西南布依族苗族自治州",
                "label": "黔西南布依族苗族自治州"
            }, {"value": "毕节地区", "label": "毕节地区"}, {
                "value": "黔东南苗族侗族自治州",
                "label": "黔东南苗族侗族自治州"
            }, {"value": "黔南布依族苗族自治州", "label": "黔南布依族苗族自治州"}], "value": "贵州省", "label": "贵州省"
        },
        {
            "children": [{"value": "南昌市", "label": "南昌市"}, {"value": "景德镇市", "label": "景德镇市"}, {
                "value": "萍乡市",
                "label": "萍乡市"
            }, {"value": "九江市", "label": "九江市"}, {"value": "新余市", "label": "新余市"}, {
                "value": "鹰潭市",
                "label": "鹰潭市"
            }, {"value": "赣州市", "label": "赣州市"}, {"value": "吉安市", "label": "吉安市"}, {
                "value": "宜春市",
                "label": "宜春市"
            }, {"value": "抚州市", "label": "抚州市"}, {"value": "上饶市", "label": "上饶市"}], "value": "江西省", "label": "江西省"
        },
        {"children": [{"value": "上海市", "label": "上海市"}], "value": "上海", "label": "上海"},
        {
            "children": [{"value": "西安市", "label": "西安市"}, {"value": "铜川市", "label": "铜川市"}, {
                "value": "宝鸡市",
                "label": "宝鸡市"
            }, {"value": "咸阳市", "label": "咸阳市"}, {"value": "渭南市", "label": "渭南市"}, {
                "value": "延安市",
                "label": "延安市"
            }, {"value": "汉中市", "label": "汉中市"}, {"value": "榆林市", "label": "榆林市"}, {
                "value": "安康市",
                "label": "安康市"
            }, {"value": "商洛市", "label": "商洛市"}], "value": "陕西省", "label": "陕西省"
        },
        {
            "children": [{"value": "杭州市", "label": "杭州市"}, {"value": "宁波市", "label": "宁波市"}, {
                "value": "温州市",
                "label": "温州市"
            }, {"value": "嘉兴市", "label": "嘉兴市"}, {"value": "湖州市", "label": "湖州市"}, {
                "value": "绍兴市",
                "label": "绍兴市"
            }, {"value": "舟山市", "label": "舟山市"}, {"value": "衢州市", "label": "衢州市"}, {
                "value": "金华市",
                "label": "金华市"
            }, {"value": "台州市", "label": "台州市"}, {"value": "丽水市", "label": "丽水市"}], "value": "浙江省", "label": "浙江省"
        },
        {
            "children": [{"value": "广州市", "label": "广州市"}, {"value": "韶关市", "label": "韶关市"}, {
                "value": "深圳市",
                "label": "深圳市"
            }, {"value": "珠海市", "label": "珠海市"}, {"value": "汕头市", "label": "汕头市"}, {
                "value": "佛山市",
                "label": "佛山市"
            }, {"value": "江门市", "label": "江门市"}, {"value": "湛江市", "label": "湛江市"}, {
                "value": "茂名市",
                "label": "茂名市"
            }, {"value": "肇庆市", "label": "肇庆市"}, {"value": "惠州市", "label": "惠州市"}, {
                "value": "梅州市",
                "label": "梅州市"
            }, {"value": "汕尾市", "label": "汕尾市"}, {"value": "河源市", "label": "河源市"}, {
                "value": "阳江市",
                "label": "阳江市"
            }, {"value": "清远市", "label": "清远市"}, {"value": "东莞市", "label": "东莞市"}, {
                "value": "中山市",
                "label": "中山市"
            }, {"value": "潮州市", "label": "潮州市"}, {"value": "揭阳市", "label": "揭阳市"}, {"value": "云浮市", "label": "云浮市"}],
            "value": "广东省",
            "label": "广东省"
        },
        {
            "children": [{"value": "乌鲁木齐市", "label": "乌鲁木齐市"}, {"value": "克拉玛依市", "label": "克拉玛依市"}, {
                "value": "吐鲁番地区",
                "label": "吐鲁番地区"
            }, {"value": "哈密地区", "label": "哈密地区"}, {"value": "昌吉回族自治州", "label": "昌吉回族自治州"}, {
                "value": "博尔塔拉蒙古自治州",
                "label": "博尔塔拉蒙古自治州"
            }, {"value": "巴音郭楞蒙古自治州", "label": "巴音郭楞蒙古自治州"}, {
                "value": "阿克苏地区",
                "label": "阿克苏地区"
            }, {"value": "克孜勒苏柯尔克孜自治州", "label": "克孜勒苏柯尔克孜自治州"}, {"value": "喀什地区", "label": "喀什地区"}, {
                "value": "和田地区",
                "label": "和田地区"
            }, {"value": "伊犁哈萨克自治州", "label": "伊犁哈萨克自治州"}, {"value": "塔城地区", "label": "塔城地区"}, {
                "value": "阿勒泰地区",
                "label": "阿勒泰地区"
            }, {"value": "石河子市", "label": "石河子市"}, {"value": "阿拉尔市", "label": "阿拉尔市"}, {
                "value": "图木舒克市",
                "label": "图木舒克市"
            }, {"value": "五家渠市", "label": "五家渠市"}], "value": "新疆维吾尔自治区", "label": "新疆维吾尔自治区"
        },
        {
            "children": [{"value": "福州市", "label": "福州市"}, {"value": "厦门市", "label": "厦门市"}, {
                "value": "莆田市",
                "label": "莆田市"
            }, {"value": "三明市", "label": "三明市"}, {"value": "泉州市", "label": "泉州市"}, {
                "value": "漳州市",
                "label": "漳州市"
            }, {"value": "南平市", "label": "南平市"}, {"value": "龙岩市", "label": "龙岩市"}, {"value": "宁德市", "label": "宁德市"}],
            "value": "福建省",
            "label": "福建省"
        },
        {
            "children": [{"value": "郑州市", "label": "郑州市"}, {"value": "开封市", "label": "开封市"}, {
                "value": "洛阳市",
                "label": "洛阳市"
            }, {"value": "平顶山市", "label": "平顶山市"}, {"value": "安阳市", "label": "安阳市"}, {
                "value": "鹤壁市",
                "label": "鹤壁市"
            }, {"value": "新乡市", "label": "新乡市"}, {"value": "焦作市", "label": "焦作市"}, {
                "value": "濮阳市",
                "label": "濮阳市"
            }, {"value": "许昌市", "label": "许昌市"}, {"value": "漯河市", "label": "漯河市"}, {
                "value": "三门峡市",
                "label": "三门峡市"
            }, {"value": "南阳市", "label": "南阳市"}, {"value": "商丘市", "label": "商丘市"}, {
                "value": "信阳市",
                "label": "信阳市"
            }, {"value": "周口市", "label": "周口市"}, {"value": "驻马店市", "label": "驻马店市"}, {"value": "济源市", "label": "济源市"}],
            "value": "河南省",
            "label": "河南省"
        },
        {
            "children": [{"value": "拉萨市", "label": "拉萨市"}, {"value": "昌都地区", "label": "昌都地区"}, {
                "value": "山南地区",
                "label": "山南地区"
            }, {"value": "日喀则地区", "label": "日喀则地区"}, {"value": "那曲地区", "label": "那曲地区"}, {
                "value": "阿里地区",
                "label": "阿里地区"
            }, {"value": "林芝地区", "label": "林芝地区"}], "value": "西藏自治区", "label": "西藏自治区"
        },
        {"children": [{"value": "重庆市", "label": "重庆市"}], "value": "重庆", "label": "重庆"},
        {
            "children": [{"value": "海口市", "label": "海口市"}, {"value": "三亚市", "label": "三亚市"}, {
                "value": "五指山市",
                "label": "五指山市"
            }, {"value": "琼海市", "label": "琼海市"}, {"value": "儋州市", "label": "儋州市"}, {
                "value": "文昌市",
                "label": "文昌市"
            }, {"value": "万宁市", "label": "万宁市"}, {"value": "东方市", "label": "东方市"}, {
                "value": "定安县",
                "label": "定安县"
            }, {"value": "屯昌县", "label": "屯昌县"}, {"value": "澄迈县", "label": "澄迈县"}, {
                "value": "临高县",
                "label": "临高县"
            }, {"value": "白沙黎族自治县", "label": "白沙黎族自治县"}, {"value": "昌江黎族自治县", "label": "昌江黎族自治县"}, {
                "value": "乐东黎族自治县",
                "label": "乐东黎族自治县"
            }, {"value": "陵水黎族自治县", "label": "陵水黎族自治县"}, {
                "value": "保亭黎族苗族自治县",
                "label": "保亭黎族苗族自治县"
            }, {"value": "琼中黎族苗族自治县", "label": "琼中黎族苗族自治县"}, {"value": "西沙群岛", "label": "西沙群岛"}, {
                "value": "南沙群岛",
                "label": "南沙群岛"
            }, {"value": "中沙群岛的岛礁及其海域", "label": "中沙群岛的岛礁及其海域"}], "value": "海南省", "label": "海南省"
        },
        {
            "children": [{"value": "中西区", "label": "中西区"}, {"value": "东区", "label": "东区"}, {
                "value": "九龙城区",
                "label": "九龙城区"
            }, {"value": "观塘区", "label": "观塘区"}, {"value": "南区", "label": "南区"}, {
                "value": "深水埗区",
                "label": "深水埗区"
            }, {"value": "黄大仙区", "label": "黄大仙区"}, {"value": "湾仔区", "label": "湾仔区"}, {
                "value": "油尖旺区",
                "label": "油尖旺区"
            }, {"value": "离岛区", "label": "离岛区"}, {"value": "葵青区", "label": "葵青区"}, {
                "value": "北区",
                "label": "北区"
            }, {"value": "西贡区", "label": "西贡区"}, {"value": "沙田区", "label": "沙田区"}, {
                "value": "屯门区",
                "label": "屯门区"
            }, {"value": "大埔区", "label": "大埔区"}, {"value": "荃湾区", "label": "荃湾区"}, {"value": "元朗区", "label": "元朗区"}],
            "value": "香港特别行政区",
            "label": "香港特别行政区"
        },
        {"children": [{"value": "澳门特别行政区", "label": "澳门特别行政区"}], "value": "澳门特别行政区", "label": "澳门特别行政区"},
        {
            "children": [{"value": "银川市", "label": "银川市"}, {"value": "石嘴山市", "label": "石嘴山市"}, {
                "value": "吴忠市",
                "label": "吴忠市"
            }, {"value": "固原市", "label": "固原市"}, {"value": "中卫市", "label": "中卫市"}],
            "value": "宁夏回族自治区",
            "label": "宁夏回族自治区"
        },
        {
            "children": [{"value": "武汉市", "label": "武汉市"}, {"value": "黄石市", "label": "黄石市"}, {
                "value": "十堰市",
                "label": "十堰市"
            }, {"value": "宜昌市", "label": "宜昌市"}, {"value": "襄樊市", "label": "襄樊市"}, {
                "value": "鄂州市",
                "label": "鄂州市"
            }, {"value": "荆门市", "label": "荆门市"}, {"value": "孝感市", "label": "孝感市"}, {
                "value": "荆州市",
                "label": "荆州市"
            }, {"value": "黄冈市", "label": "黄冈市"}, {"value": "咸宁市", "label": "咸宁市"}, {
                "value": "随州市",
                "label": "随州市"
            }, {"value": "恩施土家族苗族自治州", "label": "恩施土家族苗族自治州"}, {"value": "仙桃市", "label": "仙桃市"}, {
                "value": "潜江市",
                "label": "潜江市"
            }, {"value": "天门市", "label": "天门市"}, {"value": "神农架林区", "label": "神农架林区"}], "value": "湖北省", "label": "湖北省"
        },
        {
            "children": [{"value": "兰州市", "label": "兰州市"}, {"value": "嘉峪关市", "label": "嘉峪关市"}, {
                "value": "金昌市",
                "label": "金昌市"
            }, {"value": "白银市", "label": "白银市"}, {"value": "天水市", "label": "天水市"}, {
                "value": "武威市",
                "label": "武威市"
            }, {"value": "张掖市", "label": "张掖市"}, {"value": "平凉市", "label": "平凉市"}, {
                "value": "酒泉市",
                "label": "酒泉市"
            }, {"value": "庆阳市", "label": "庆阳市"}, {"value": "定西市", "label": "定西市"}, {
                "value": "陇南市",
                "label": "陇南市"
            }, {"value": "临夏回族自治州", "label": "临夏回族自治州"}, {"value": "甘南藏族自治州", "label": "甘南藏族自治州"}],
            "value": "甘肃省",
            "label": "甘肃省"
        },
        {
            "children": [{"value": "沈阳市", "label": "沈阳市"}, {"value": "大连市", "label": "大连市"}, {
                "value": "鞍山市",
                "label": "鞍山市"
            }, {"value": "抚顺市", "label": "抚顺市"}, {"value": "本溪市", "label": "本溪市"}, {
                "value": "丹东市",
                "label": "丹东市"
            }, {"value": "锦州市", "label": "锦州市"}, {"value": "营口市", "label": "营口市"}, {
                "value": "阜新市",
                "label": "阜新市"
            }, {"value": "辽阳市", "label": "辽阳市"}, {"value": "盘锦市", "label": "盘锦市"}, {
                "value": "铁岭市",
                "label": "铁岭市"
            }, {"value": "朝阳市", "label": "朝阳市"}, {"value": "葫芦岛市", "label": "葫芦岛市"}], "value": "辽宁省", "label": "辽宁省"
        },
        {
            "children": [{"value": "石家庄市", "label": "石家庄市"}, {"value": "唐山市", "label": "唐山市"}, {
                "value": "秦皇岛市",
                "label": "秦皇岛市"
            }, {"value": "邯郸市", "label": "邯郸市"}, {"value": "邢台市", "label": "邢台市"}, {
                "value": "保定市",
                "label": "保定市"
            }, {"value": "张家口市", "label": "张家口市"}, {"value": "承德市", "label": "承德市"}, {
                "value": "衡水市",
                "label": "衡水市"
            }, {"value": "廊坊市", "label": "廊坊市"}, {"value": "沧州市", "label": "沧州市"}], "value": "河北省", "label": "河北省"
        },
        {
            "children": [{"value": "西宁市", "label": "西宁市"}, {"value": "海东地区", "label": "海东地区"}, {
                "value": "海北藏族自治州",
                "label": "海北藏族自治州"
            }, {"value": "黄南藏族自治州", "label": "黄南藏族自治州"}, {"value": "海南藏族自治州", "label": "海南藏族自治州"}, {
                "value": "果洛藏族自治州",
                "label": "果洛藏族自治州"
            }, {"value": "玉树藏族自治州", "label": "玉树藏族自治州"}, {"value": "海西蒙古族藏族自治州", "label": "海西蒙古族藏族自治州"}],
            "value": "青海省",
            "label": "青海省"
        }
        , {"value": "未知", "label": "未知"}
    ]
export const minzu = [
    {"value": "汉族", "label": "汉族"},
    {"value": "蒙古族", "label": "蒙古族"},
    {"value": "回族", "label": "回族"},
    {"value": "藏族", "label": "藏族"},
    {"value": "维吾尔族", "label": "维吾尔族"},
    {"value": "苗族", "label": "苗族"},
    {"value": "彝族", "label": "彝族"},
    {"value": "壮族", "label": "壮族"},
    {"value": "布依族", "label": "布依族"},
    {"value": "朝鲜族", "label": "朝鲜族"},
    {"value": "满族", "label": "满族"},
    {"value": "侗族", "label": "侗族"},
    {"value": "瑶族", "label": "瑶族"},
    {"value": "白族	", "label": "白族"},
    {"value": "土家族", "label": "土家族"},
    {"value": "哈尼族", "label": "哈尼族"},
    {"value": "哈萨克族", "label": "哈萨克族"},
    {"value": "傣族", "label": "傣族"},
    {"value": "黎族", "label": "黎族"},
    {"value": "傈僳族", "label": "傈僳族"},
    {"value": "佤族", "label": "佤族"},
    {"value": "畲族", "label": "畲族"},
    {"value": "拉祜族", "label": "拉祜族"},
    {"value": "水族", "label": "水族"},
    {"value": "东乡族", "label": "东乡族"},
    {"value": "纳西族", "label": "纳西族"},
    {"value": "景颇族", "label": "景颇族"},
    {"value": "柯尔克孜族", "label": "柯尔克孜族"},
    {"value": "土族", "label": "土族"},
    {"value": "达斡尔族", "label": "达斡尔族"},
    {"value": "仫佬族", "label": "仫佬族"},
    {"value": "羌族	", "label": "羌族"},
    {"value": "布朗族", "label": "布朗族"},
    {"value": "撒拉族", "label": "撒拉族"},
    {"value": "毛南族", "label": "毛南族"},
    {"value": "仡佬族", "label": "仡佬族"},
    {"value": "锡伯族", "label": "锡伯族"},
    {"value": "阿昌族", "label": "阿昌族"},
    {"value": "普米族", "label": "普米族"},
    {"value": "塔吉克族", "label": "塔吉克族"},
    {"value": "怒族", "label": "怒族"},
    {"value": "乌兹别克族", "label": "乌兹别克族"},
    {"value": "俄罗斯族", "label": "俄罗斯族"},
    {"value": "鄂温克族", "label": "鄂温克族"},
    {"value": "德昂族", "label": "德昂族"},
    {"value": "保安族", "label": "保安族"},
    {"value": "裕固族", "label": "裕固族"},
    {"value": "京族	", "label": "京族"},
    {"value": "塔塔尔族", "label": "塔塔尔族"},
    {"value": "独龙族", "label": "独龙族"},
    {"value": "鄂伦春族", "label": "鄂伦春族"},
    {"value": "赫哲族", "label": "赫哲族"},
    {"value": "门巴族", "label": "门巴族"},
    {"value": "珞巴族", "label": "珞巴族"},
    {"value": "基诺族", "label": "基诺族"},
    {"value": "高山族", "label": "高山族"}
]
export const sectionlist = [
    {"value": "caseflag__is_jibenxinxi", "label": "基本信息"},
    {"value": "caseflag__is_linchuangxinxi", "label": "临床信息"},
    {"value": "caseflag__is_xibaoyichuan", "label": "细胞遗传"},
    {"value": "caseflag__is_fenzibiaozhi", "label": "分子标志"},
    {"value": "caseflag__is_mianyibiaoxing", "label": "免疫表型"},
    {"value": "caseflag__is_zhiliaoxinxi", "label": "治疗信息"},
    {"value": "all", "label": "全部"},
]
export const jibenxinxi = [
    {value: "id", label: 'ID'},
    {value: "status_tag", label: '多源共享数据分类'},
    {value: "xingming", label: '姓名'},
    {value: "shenfenzheng", label: '身份证'},
    {value: "nianling", label: '年龄'},
    {value: "xingbie", label: '性别'},
    {value: "minzu", label: '民族'},
    {value: "zhiye", label: '职业'},
    {value: "hunyin", label: '婚姻'},
    {value: "dianhua", label: '联系电话'},
    {value: "huji", label: '户籍所在地'},
    {value: "user__username", label: '账号'},
    {value: "jiuzhennianling", label: '就诊年龄'},
    {value: "zhuangtai", label: '状态'},
    {value: "zhuangui_rk", label: '备注'},
    {value: "is_image", label: '图片报告'},
    {value: "lianxifangshi", label: '其他联系方式'},
    {value: "lianxidizhi", label: '联系地址'},
    {value: "shouzhiyiyuan", label: '医院'},
    {value: 'linchuangxinxi', label: '临床信息'},
    {value: 'xibaoyichuan', label: '细胞遗传'},
    {value: 'fenzibiaozhi', label: '分子标志'},
    {value: 'mianyibiaoxing', label: '免疫表型'},
    {value: 'zhiliaoxinxi', label: '治疗信息'},
    {value: 'zhuanguifeiyong', label: '转归费用'},
    {value: 'weiwanzhengshuju', label: '未完整数据'},
    {value: 'alfenlei', label: '诊断分类'},
    {value: 'diag_date', label: '就诊时间'},
]
export const linchuangxinxi =
    [
        {
            value: 'xuechanggui',
            label: '血常规',
            children:
                [
                    {
                        value: 'xuechanggui_wbc',
                        label: 'WBC(白细胞)',
                    },
                    {
                        value: 'xuechanggui_rbc',
                        label: 'RBC(红细胞计数)',
                    },
                    {
                        value: 'xuechanggui_hb',
                        label: 'HB(血红蛋白)',
                    },
                    {
                        value: 'xuechanggui_plt',
                        label: 'PLT(血小板)',
                    },
                ]
        }, {
        value: 'xibaoxingtai',
        label: '细胞形态',
        children:
            [
                {
                    value: 'xibaoxingtai_gusuiyuanxibao',
                    label: '骨髓原始细胞',
                },
                {
                    value: 'xibaoxingtai_waizhouxuyuanshixibao',
                    label: '外周血原始细胞',
                }
            ]
    }, {
        value: 'chuningxuezhibiao',
        label: '出凝血指标',
        children:
            [
                {
                    value: 'chuningxuezhibiao_aptt',
                    label: 'APTT(活化部分凝血活酶时间)',
                },
                {
                    value: 'chuningxuezhibiao_pt',
                    label: 'PT(凝血酶原时间)',
                },
                {
                    value: 'chuningxuezhibiao_tt',
                    label: 'TT(凝血酶时间)',
                },
                {
                    value: 'chuningxuezhibiao_fib',
                    label: 'FIB(纤维蛋白原)',
                },
                {
                    value: 'chuningxuezhibiao_fdp',
                    label: 'FDP(纤维蛋白（原）降解产物)',
                },
                {
                    value: 'chuningxuezhibiao_d_dimmer',
                    label: 'D-Dimmer(D-二聚体)',
                },
            ]
    }, {
        value: 'gangongneng',
        label: '肝功能',
        children:
            [
                {
                    value: 'gangongneng_alt',
                    label: 'ALT(谷丙转氨酶)',
                },
                {
                    value: 'gangongneng_ast',
                    label: 'AST(谷草转氨酶)',
                },
                {
                    value: 'gangongneng_akp',
                    label: 'AKP(血清碱性磷酸酶)',
                },
                {
                    value: 'gangongneng_ggt',
                    label: 'GGT(γ-谷氨酸转肽酶)',
                },
                {
                    value: 'gangongneng_ldh',
                    label: 'LDH(乳酸脱氢酶)',
                },
                {
                    value: 'gangongneng_tbil',
                    label: 'TBIL(总胆红素)',
                },
                {
                    value: 'gangongneng_dbil',
                    label: 'DBIL(直接胆红素)',
                },
                {
                    value: 'gangongneng_alb',
                    label: 'ALB(白蛋白)',
                }
            ]
    }, {
        value: 'shengongneng',
        label: '肾功能',
        children:
            [
                {
                    value: 'shengongneng_bun',
                    label: 'BUN(血尿素氮)',
                },
                {
                    value: 'shengongneng_cr',
                    label: 'CR(血肌酐)',
                },
                {
                    value: 'shengongneng_ua',
                    label: 'UA(尿酸)',
                }
            ]
    }, {
        value: 'dianjiezhi',
        label: '电解质',
        children:
            [
                {
                    value: 'dianjiezhi_na',
                    label: 'Na+',
                },
                {
                    value: 'dianjiezhi_k',
                    label: 'K+',
                },
                {
                    value: 'dianjiezhi_ci',
                    label: 'CI-',
                },
                {
                    value: 'dianjiezhi_ca',
                    label: 'CA++',
                }
            ]
    },
    ]
export const xibaoyichuan = [
    {
        value: 'aml',
        label: 'AML',
        children:
            [
                {
                    value: '正常核型',
                    label: '正常核型',
                },
                {
                    value: '单体核型',
                    label: '单体核型',
                },
                {
                    value: '复杂核型（≥3种）',
                    label: '复杂核型（≥3种）',
                },
                {
                    value: 't(8;21) (q22;q22)',
                    label: 't(8;21) (q22;q22)',
                },
                {
                    value: 'inv(16) (p13;q22) 或 t(16;16) (p13;q22)',
                    label: 'inv(16) (p13;q22) 或 t(16;16) (p13;q22)',
                },
                {
                    value: 't(15;17) (q24;q21)',
                    label: 't(15;17) (q24;q21)',
                },
                {
                    value: 't(9;22)(q34.1;q11.2)',
                    label: 't(9;22)(q34.1;q11.2)',
                },
                {
                    value: 't(9;11) (p22;q23)',
                    label: 't(9;11) (p22;q23)',
                },
                {
                    value: '除t(9;11)外的11q23染色体易位',
                    label: '除t(9;11)外的11q23染色体易位',
                },
                {
                    value: '-5/5q-',
                    label: '-5/5q-',
                },
                {
                    value: '-7/7q-',
                    label: '-7/7q-',
                },
                {
                    value: '-17/abn(17p)',
                    label: '-17/abn(17p)',
                },
                {
                    value: 'inv(3) (q21;q26.2) 或 t(3;3) (q21;q26.2)',
                    label: 'inv(3) (q21;q26.2) 或 t(3;3) (q21;q26.2)',
                },
                {
                    value: 't(6;9)(p23;q34)',
                    label: 't(6;9)(p23;q34)',
                },
                {
                    value: '不详',
                    label: '不详',
                },
            ]
    }, {
        value: 'all',
        label: 'ALL',
        children:
            [
                {
                    value: '正常核型',
                    label: '正常核型',
                },
                {
                    value: '复杂核型（≥5种）',
                    label: '复杂核型（≥5种）',
                },
                {
                    value: '高二倍体（51-65）',
                    label: '高二倍体（51-65）',
                },
                {
                    value: '近单倍体（30-39）',
                    label: '近单倍体（30-39）',
                },
                {
                    value: 't(9;22)(q23;p13.3)',
                    label: 't(9;22)(q23;p13.3)',
                },
                {
                    value: 't(12;21)(p13;q22)',
                    label: 't(12;21)(p13;q22)',
                },
                {
                    value: 't(v;11q23)',
                    label: 't(v;11q23)',
                },
                {
                    value: 't(1;19)(q34;q11)',
                    label: 't(1;19)(q34;q11)',
                },
                {
                    value: 't(5;14)(q31;q32)',
                    label: 't(5;14)(q31;q32)',
                },
                {
                    value: 'iamp21',
                    label: 'iamp21',
                },
                {
                    value: '不详',
                    label: '不详',
                }
            ]
    }]
export const mianyibiaoxing = [
    {
        value: 'b',
        label: 'B系',
        children:
            [
                {
                    value: 'cd19',
                    label: 'CD19',
                },
                {
                    value: 'cd20',
                    label: 'CD20',
                },
                {
                    value: 'cd22',
                    label: 'CD22',
                },
                {
                    value: 'cd79a',
                    label: 'CD79a',
                },
                {
                    value: 'cyu',
                    label: 'Cyu',
                },
                {
                    value: 'cd10',
                    label: 'CD10',
                },
            ]
    }, {
        value: 't',
        label: 'T系',
        children:
            [
                {
                    value: 'ccd3',
                    label: 'cCD3',
                },
                {
                    value: 'cd4',
                    label: 'CD4',
                },
                {
                    value: 'cd8',
                    label: 'CD8',
                },
                {
                    value: 'cd5',
                    label: 'CD5',
                },
                {
                    value: 'cd7',
                    label: 'CD7',
                },
                {
                    value: 'tdt',
                    label: 'TdT',
                },
                {
                    value: 'cd1a',
                    label: 'CD1a',
                },
                {
                    value: 'cd2',
                    label: 'CD2',
                },
                {
                    value: 'cd56',
                    label: 'CD56',
                }
            ]
    }, {
        value: 'G',
        label: '髓系',
        children:
            [
                {
                    value: 'cd13',
                    label: 'CD13',
                },
                {
                    value: 'cd33',
                    label: 'CD33',
                },
                {
                    value: 'mpo',
                    label: 'MPO',
                },
                {
                    value: 'cd117',
                    label: 'CD117',
                },
                {
                    value: 'cd34',
                    label: 'CD34',
                },
                {
                    value: 'cd11b',
                    label: 'CD11b',
                },
                {
                    value: 'cd14',
                    label: 'CD14',
                },
                {
                    value: 'cd15',
                    label: 'CD15',
                },
                {
                    value: 'hla_dr',
                    label: 'HLA-DR',
                }
            ]
    }
]
export const zhiliaoxinxi = [
    {value: '标准治疗方案', label: '标准治疗方案'},
    {value: 'APL的治疗方案', label: 'APL的治疗方案'},
    {value: '姑息治疗', label: '姑息治疗'},
    {value: '去甲基化治疗', label: '去甲基化治疗'},
    {value: '以VDCP为骨架的方案', label: '以VDCP为骨架的方案'},
    {value: '新药临床试验', label: '新药临床试验'},
]
export const zhuangtai = [
    {
        value: '存活',
        label: '存活',
    },
    {
        value: '死亡',
        label: '死亡',
    },
    {
        value: '放弃',
        label: '放弃',
    },
    {
        value: '失访',
        label: '失访',
    },
    {
        value: '1',
        label: '随访待更新',
    }
]

export const zhuanguifeiyong = [
    {
        value: 'zhiliaozhuangtai',
        label: '治疗状态',
        children:
            [
                {
                    value: '完成治疗',
                    label: '完成治疗',
                },
                {
                    value: '提前终止治疗',
                    label: '提前终止治疗',
                },
                {
                    value: '正在治疗',
                    label: '正在治疗',
                },
                {
                    value: '未治',
                    label: '未治',
                }
            ]
    }, {
        value: 'shengcunzhuangtai',
        label: '生存状态',
        children:
            [
                {
                    value: '存活',
                    label: '存活',
                },
                {
                    value: '死亡',
                    label: '死亡',
                },
                {
                    value: '放弃',
                    label: '放弃',
                },
                {
                    value: '失访',
                    label: '失访',
                }
            ]
    }, {
        value: 'yibaoleixing',
        label: '医保类型',
        children:
            [
                {
                    value: '城镇职工',
                    label: '城镇职工',
                },
                {
                    value: '城镇居民',
                    label: '城镇居民',
                },
                {
                    value: '新农合',
                    label: '新农合',
                },
                {
                    value: '重大疾病医疗保险',
                    label: '重大疾病医疗保险',
                },
                {
                    value: '商业保险',
                    label: '商业保险',
                },
                {
                    value: '外地医保',
                    label: '外地医保',
                },
                {
                    value: '自费',
                    label: '自费',
                }
            ]
    }
]
export const fenzi = [
    'qita_content',
    'aml_cbfb_myh11',
    'aml_tsl_erg',
    'aml_runx1_runxt1',
    'aml_bcr_abl1',
    'aml_pml_rara',
    'aml_nup98',
    'aml_kmt2a',
    'aml_mkt2a',
    'aml_rara',
    'aml_tls_erg',
    'aml_dek_nup214',
    // mutation
    'aml_npm1',
    'aml_dnmt3a',
    'aml_cebpa',
    'aml_c_kit',
    'aml_cebpa2',
    'aml_nras',
    'aml_flt3_itd',
    'aml_asxl1',
    'aml_runx1',
    'aml_flt3_tkd',
    'aml_idh1',
    'aml_mll_ptd',
    'aml_idh2',
    'aml_tp53',
    'aml_tet2',
    // ball
    'ball_bcr_abl1',
    'ball_ph_like',
    'ball_kmt2a',
    'ball_etv6_runx1',
    'ball_tcf3_pbx1',
    'ball_tcf34_hlf',
    'ball_pax5',
    'ball_crlf2',
    'ball_znf384',
    'ball_dux4',
    'ball_mef2d',
    'ball_nutm1',
    'ball_igh',
    // ball mutation
    'ball_ikzf1_ik6',
    'ball_ikzf1_n159y',
    'ball_pax5_p80r',
    'ball_zeb2_h1038r',
    // tall
    'tall_tal1',
    'tall_tal1_high',
    'tall_tal2',
    'tall_tal2_high',
    'tall_tlx1',
    'tall_tlx1_high',
    'tall_tlx3',
    'tall_tlx3_high',
    'tall_hoxa10',
    'tall_hoxa_high',
    'tall_spi1',
    'tall_spi1_high',
    'tall_lmo1',
    'tall_lmo1_high',
    'tall_lmo2',
    'tall_lmo2_high',
    'tall_nkx21',
    'tall_nkx21_high',
    'tall_set_nup214',
    'tall_kmt2a',
    'tall_lyl1_high',
    'tall_mef2c_high',
    'tall_mllt10',
    'tall_abl1',
    'tall_myb',
    'tall_tcr',
    'tall_notch1',
    'tall_fbxw7',
    'tall_phf6',
    'tall_jak1',
    'tall_jak3',
    'tall_pten',
    'tall_nras',
    'tall_kras',
    'tall_usp7',
    'tall_gata3',
    'tall_rpl10',
]
export const amlfusion = [
    {
        type: 'amlfusion',
        value: 'aml_runx1_runxt1',
        label: 'RUNX1-RUNXT1(AML1-ETO)',
        partner: '',
        id: 1

    },
    {
        type: 'amlfusion',
        value: 'aml_cbfb_myh11',
        label: 'CBFβ-MYH11',
        partner: '',
        id: 2
    },
    {
        type: 'amlfusion',
        value: 'aml_bcr_abl1',
        label: 'BCR-ABL1',
        partner: '',
        id: 3
    },
    {
        type: 'amlfusion',
        value: 'aml_pml_rara',
        label: 'PML-RARα',
        partner: '',
        id: 4
    },
    {
        type: 'amlfusion',
        value: 'aml_nup98',
        label: 'NUP98 相关融合',
        partner: 'aml_nup98_conntent',
        id: 5
    },
    {
        type: 'amlfusion',
        value: 'aml_mkt2a',
        label: 'KMT2A(MLL) 相关融合',
        partner: 'aml_kmt2a_content',
        id: 6
    },
    {
        type: 'amlfusion',
        value: 'aml_rara',
        label: 'RARα相关融合(除PML-RARa)',
        partner: 'aml_rara_content',
        id: 7
    },
    {
        type: 'amlfusion',
        value: 'aml_tsl_erg',
        label: 'TLS-ERG',
        partner: '',
        id: 8
    },
    {
        type: 'amlfusion',
        value: 'aml_dek_nup214',
        label: 'DEK-NUP214',
        partner: '',
        id: 9
    },
]
export const amlmutation = [
    {
        type: 'amlmutation',
        value: 'aml_npm1',
        label: 'NPM1',
        partner: 'aml_npm1_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_cebpa',
        label: 'CEBPA 单等位基因突变',
        partner: 'aml_cebpa_point',
        content: 'CEBPA单等位基因突变指只有N端或C端突变',
    },
    {
        type: 'amlmutation',
        value: 'aml_cebpa2',
        label: 'CEBPA 双等位基因',
        partner: 'aml_cebpa2_point',
        content: 'CEBPA双等位基因指同时存在N端和C端突变',
    },
    {
        type: 'amlmutation',
        value: 'aml_flt3_itd',
        label: 'FLT3-ITD',
        content: '',

    },
    {
        type: 'amlmutation',
        value: 'aml_flt3_tkd',
        label: 'FLT3-TKD',
        partner: 'aml_flt3_tkd_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_mll_ptd',
        label: 'KMT2A(MLL)-PTD',
        partner: 'aml_mll_ptd_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_tp53',
        label: 'TP53',
        partner: 'aml_tp53_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_bcor',
        label: 'BCOR',
        partner: 'aml_bcor_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_ezh2',
        label: 'EZH2',
        partner: 'aml_ezh2_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_sf3b1',
        label: 'SF3B1',
        partner: 'aml_sf3b1_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_srsf2',
        label: 'SRSF2',
        partner: 'aml_srsf2_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_stag2',
        label: 'STAG2',
        partner: 'aml_stag2_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_u2af1',
        label: 'U2AF1',
        partner: 'aml_u2af1_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_zrsr2',
        label: 'ZRSR2',
        partner: 'aml_zrsr2_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_cebpa_bzip',
        label: 'CEBPA bzip突变',
        partner: 'aml_cebpa_bzip_point',
        content: '',
    },
    {
        type: 'amlmutation',
        value: 'aml_mecom',
        label: 'MECOM重排',
        partner: 'aml_mecom_point',
        content: '',
    }
]
export const amlmutationn = [
    {
        type: 'amlmutationn',
        value: 'aml_dnmt3a',
        label: 'DNMT3A',
        partner: 'aml_dnmt3a_point',
        content: ''
    },
    {
        type: 'amlmutationn',
        value: 'aml_c_kit',
        partner: 'aml_c_kit_point',
        label: 'C-KIT',
    },
    {
        type: 'amlmutationn',
        value: 'aml_nras',
        label: 'NRAS',
        partner: 'aml_nras_point',
        content: ''
    },
    {
        type: 'amlmutationn',
        value: 'aml_asxl1',
        label: 'ASXL1',
        partner: 'aml_asxl1_point',
        content: ''
    },
    {
        type: 'amlmutationn',
        value: 'aml_idh1',
        label: 'IDH1',
        partner: 'aml_idh1_point',
        content: ''
    },
    {
        type: 'amlmutationn',
        value: 'aml_idh2',
        label: 'IDH2',
        partner: 'aml_idh2_point',
        content: ''
    },
    {
        type: 'amlmutationn',
        value: 'aml_tet2',
        label: 'TET2',
        partner: 'aml_tet2_point',
        content: ''
    },
    {
        type: 'amlmutationn',
        value: 'aml_runx1',
        label: 'RUNX1',
        partner: 'aml_runx1_point',
        content: ''
    }
]
export const tallfusion = [
    {
        type: 'tallfusion',
        value: 'tall_tal1',
        label: 'TAL1 相关融合',
        partner: 'tall_tal1_content',

    },
    {
        type: 'tallfusion',
        value: 'tall_tal2',
        label: 'TAL2 相关融合',
        partner: 'tall_tal2_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_tlx1',
        label: 'TLX1 相关融合',
        partner: 'tlx1_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_tlx3',
        label: 'TLX3 相关融合',
        partner: 'tall_tlx3_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_hoxa10',
        label: 'HOXA10 相关融合',
        partner: 'tall_hoxa10_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_spi1',
        label: 'SPI1 相关融合',
        partner: 'tall_spi1_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_lmo1',
        label: 'LMO1 相关融合',
        partner: 'tall_lmo1_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_lmo2',
        label: 'LMO2 相关融合',
        partner: 'tall_lmo2_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_nkx21',
        label: 'NKX2-1 相关融合',
        partner: 'tall_nkx21_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_set_nup214',
        label: 'SET - NUP214',
        partner: '',
    },
    {
        type: 'tallfusion',
        value: 'tall_kmt2a',
        label: 'KMT2A(MLL) 相关融合',
        partner: 'tall_kmt2a_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_mllt10',
        label: 'MLLT10 相关融合',
        partner: 'tall_mllt10_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_abl1',
        label: 'ABL1 相关融合',
        partner: 'tall_abl1_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_myb',
        label: 'MYB 相关融合',
        partner: 'tall_myb_content',
    },
    {
        type: 'tallfusion',
        value: 'tall_tcr',
        label: 'TCR 相关融合',
        partner: 'tall_tcr_content',
    },
]
export const ballfusion = [
    {
        type: 'ballfusion',
        value: 'ball_bcr_abl1',
        label: 'BCR - ABL1',
        partner: '',

    },
    {
        type: 'ballfusion',
        value: 'ball_ph_like',
        label: 'Ph-like',
        partner: 'ball_ph_like_content',
    },
    {
        type: 'ballfusion',
        value: 'ball_kmt2a',
        label: 'KMT2A(MLL) 相关融合',
        partner: 'ball_kmt2a_content',
    },
    {
        type: 'ballfusion',
        value: 'ball_etv6_runx1',
        label: 'ETV6 - RUNX1',
        partner: '',
    },
    {
        type: 'ballfusion',
        value: 'ball_tcf3_pbx1',
        label: 'TCF3 - PBX1',
        partner: '',
    },
    {
        type: 'ballfusion',
        value: 'ball_tcf34_hlf',
        label: 'TCF3/4 - HLF',
        partner: '',
    },
    {
        type: 'ballfusion',
        value: 'ball_pax5',
        label: 'PAX5 相关融合',
        partner: 'ball_pax_content',
    },
    {
        type: 'ballfusion',
        value: 'ball_crlf2',
        label: 'CRLF2 相关融合',
        partner: 'ball_crlf2_content',
    },
    {
        type: 'ballfusion',
        value: 'ball_znf384',
        label: 'ZNF384 相关融合',
        partner: 'ball_znf384_content',
    },
    {
        type: 'ballfusion',
        value: 'ball_dux4',
        label: 'DUX4 相关融合',
        partner: 'ball_dux4_content',
    },
    {
        type: 'ballfusion',
        value: 'ball_mef2d',
        label: 'MEF2D 相关融合',
        partner: 'ball_mef2d_content',
    },
    {
        type: 'ballfusion',
        value: 'ball_nutm1',
        label: 'NUTM1 相关融合',
        partner: 'ball_nutm1_content',
    },
    {
        type: 'ballfusion',
        value: 'ball_igh',
        label: 'IGH 相关融合',
        partner: 'ball_igh_content',
    }
]
export const ballmutation = [
    {
        type: 'ballmutation',
        value: 'ball_ikzf1_ik6',
        label: 'IKZF1 deletion variant (Ik6)',
    },
    {
        type: 'ballmutation',
        value: 'ball_ikzf1_n159y',
        label: 'IKZF1 (p.N159Y)',
    },
    {
        type: 'ballmutation',
        value: 'ball_pax5_p80r',
        label: 'PAX5 (p.P80R)',
    },
    {
        type: 'ballmutation',
        value: 'ball_zeb2_h1038r',
        label: 'ZEB2 (p.H1038R)',
    }
]
export const dysregulation = [
    {
        type: 'dysregulation',
        value: 'tall_tal1_high',
        label: 'TAL1 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_tal2_high',
        label: 'TAL2 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_tlx1_high',
        label: 'TLX1 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_tlx3_high',
        label: 'TLX3 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_hoxa_high',
        label: 'HOXA家族 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_spi1_high',
        label: 'SPI1 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_lmo1_high',
        label: 'LMO1 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_lmo2_high',
        label: 'LMO2 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_nkx21_high',
        label: 'NKX2-1 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_lyl1_high',
        label: 'LYL1 高表达',
    },
    {
        type: 'dysregulation',
        value: 'tall_mef2c_high',
        label: 'MEF2C 高表达',
    },
]
export const tallmutation = [
    {
        type: 'tallmutation',
        value: 'tall_notch1',
        label: 'NOTCH1',
        partner: 'tall_notch1_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_fbxw7',
        label: 'FBXW7',
        partner: 'tall_fbxw7_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_phf6',
        label: 'PHF6',
        partner: 'tall_phf6_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_jak1',
        label: 'JAK1',
        partner: 'tall_jak1_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_jak3',
        label: 'JAK3',
        partner: 'tall_jak3_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_pten',
        label: 'PTEN',
        partner: 'tall_pten_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_nras',
        label: 'NRAS',
        partner: 'tall_nras_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_kras',
        label: 'KRAS',
        partner: 'tall_kras_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_usp7',
        label: 'USP7',
        partner: 'tall_usp7_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_gata3',
        label: 'GATA3',
        partner: 'tall_gata3_point',
    },
    {
        type: 'tallmutation',
        value: 'tall_rpl10',
        label: 'RPL10',
        partner: 'tall_rpl10_point',
    },
]
export const xibaoyichuanenabled = [
    // 'jiuzhenriqi',
    // 'xuechanggui_wbc',
    // 'xuechanggui_rbc',
    // 'xuechanggui_hb',
    // 'xuechanggui_plt',
    // 'chuningxuezhibiao_aptt',
    // 'chuningxuezhibiao_pt',
    // 'chuningxuezhibiao_tt',
    // 'chuningxuezhibiao_fib',
    // 'chuningxuezhibiao_fdp',
    // 'chuningxuezhibiao_d_dimmer',
    // 'zhenduanfenxing',
    // 'alfenlei',
    'xibaoxingtai_gusuiyuanxibao'
]
export const fenzibiaozhi = [
    {
        value: 'aml',
        label: 'AML',
        children:
            [
                {
                    value: 'fusion',
                    label: 'fusion',
                    children: [
                        {
                            value: 'aml_runx1_runxt1',
                            label: 'RUNX1-RUNXT1 (AML1-ETO)',
                        },
                        {
                            value: 'aml_cbfb_myh11',
                            label: 'CBFβ-MYH11',
                        },
                        {
                            value: 'aml_bcr_abl1',
                            label: 'BCR-ABL1',
                        },
                        {
                            value: 'aml_pml_rara',
                            label: 'PML-RARα',
                        },
                        {
                            value: 'aml_nup98',
                            label: 'NUP98 相关融合',
                        },
                        {
                            value: 'aml_mkt2a',
                            label: 'KMT2A(MLL) 相关融合',
                        },
                        {
                            value: 'aml_rara',
                            label: 'RARα相关融合（除PML-RARa外',
                        },
                        {
                            value: 'aml_tsl_erg',
                            label: 'TLS-ERG',
                        },
                        {
                            value: 'aml_dek_nup214',
                            label: 'DEK-NUP214',
                        },
                    ]
                },
                {
                    value: 'mutation',
                    label: 'mutation',
                    children: [
                        {
                            value: 'aml_dnmt3a',
                            label: 'DNMT3A',
                        },
                        {
                            value: 'aml_c_kit',
                            label: 'C-KIT',
                        },
                        {
                            value: 'aml_nras',
                            label: 'NRAS',
                        },
                        {
                            value: 'aml_asxl1',
                            label: 'ASXL1',
                        },
                        {
                            value: 'aml_idh1',
                            label: 'IDH1',
                        },
                        {
                            value: 'aml_idh2',
                            label: 'IDH2',
                        },
                        {
                            value: 'aml_tet2',
                            label: 'TET2',
                        },
                        {
                            value: 'aml_runx1',
                            label: 'RUNX1',
                        },
                        {
                            value: 'aml_npm1',
                            label: 'NPM1',
                        },
                        {
                            value: 'aml_cebpa',
                            label: 'CEBPA 单等位基因突变',
                        },
                        {
                            value: 'aml_cebpa2',
                            label: 'CEBPA 双等位基因',
                        },
                        {
                            value: 'aml_flt3_itd',
                            label: 'FLT3-ITD',
                        },
                        {
                            value: 'aml_flt3_tkd',
                            label: 'FLT3-TKD',
                        },
                        {
                            value: 'aml_mll_ptd',
                            label: 'KMT2A(MLL)-PTD',
                        },
                        {
                            value: 'aml_tp53',
                            label: 'TP53',
                        }
                    ]
                },
            ]
    },
    {
        value: 'ball',
        label: 'B-ALL',
        children:
            [
                {
                    value: 'fusion',
                    label: 'fusion',
                    children: [
                        {
                            value: 'ball_bcr_abl1',
                            label: 'BCR - ABL1',
                        },
                        {
                            value: 'ball_ph_like',
                            label: 'Ph-like',
                        },
                        {
                            value: 'ball_kmt2a',
                            label: 'KMT2A(MLL) 相关融合',
                        },
                        {
                            value: 'ball_etv6_runx1',
                            label: 'ETV6 - RUNX1',
                        },
                        {
                            value: 'ball_tcf3_pbx1',
                            label: 'TCF3 - PBX1',
                        },
                        {
                            value: 'ball_tcf34_hlf',
                            label: 'TCF3/4 - HLF',
                        },
                        {
                            value: 'ball_pax5',
                            label: 'PAX5 相关融合',
                        },
                        {
                            value: 'ball_crlf2',
                            label: 'CRLF2 相关融合',
                        },
                        {
                            value: 'ball_znf384',
                            label: 'ZNF384 相关融合',
                        },
                        {
                            value: 'ball_dux4',
                            label: 'DUX4 相关融合',
                        },
                        {
                            value: 'ball_mef2d',
                            label: 'MEF2D 相关融合',
                        },
                        {
                            value: 'ball_nutm1',
                            label: 'NUTM1 相关融合',
                        },
                        {
                            value: 'ball_igh',
                            label: 'IGH 相关融合',
                        }
                    ]
                },
                {
                    value: 'mutation',
                    label: 'mutation',
                    children: [
                        {
                            value: 'ball_ikzf1_ik6',
                            label: 'IKZF1 deletion variant (Ik6)',
                        },
                        {
                            value: 'ball_ikzf1_n159y',
                            label: 'IKZF1 (p.N159Y)',
                        },
                        {
                            value: 'ball_pax5_p80r',
                            label: 'PAX5 (p.P80R)',
                        },
                        {
                            value: 'ball_zeb2_h1038r',
                            label: 'ZEB2 (p.H1038R)',
                        }
                    ]
                },
            ]
    },
    {
        value: 'tall',
        label: 'T-ALL',
        children:
            [
                {
                    value: 'fusion',
                    label: 'fusion',
                    children: [
                        {
                            value: 'tall_tal1',
                            label: 'TAL1 相关融合',
                        },
                        {
                            value: 'tall_tal2',
                            label: 'TAL2 相关融合',
                        },
                        {
                            value: 'tall_tlx1',
                            label: 'TLX1 相关融合',
                        },
                        {
                            value: 'tall_tlx3',
                            label: 'TLX3 相关融合',
                        },
                        {
                            value: 'tall_hoxa10',
                            label: 'HOXA10 相关融合',
                        },
                        {
                            value: 'tall_spi1',
                            label: 'SPI1 相关融合',
                        },
                        {
                            value: 'tall_lmo1',
                            label: 'LMO1 相关融合',
                        },
                        {
                            value: 'tall_lmo2',
                            label: 'LMO2 相关融合',
                        },
                        {
                            value: 'tall_nkx21',
                            label: 'NKX2-1 相关融合',
                        },
                        {
                            value: 'tall_set_nup214',
                            label: 'SET - NUP214',
                        },
                        {
                            value: 'tall_kmt2a',
                            label: 'KMT2A(MLL) 相关融合',
                        },
                        {
                            value: 'tall_mllt10',
                            label: 'MLLT10 相关融合',
                        },
                        {
                            value: 'tall_abl1',
                            label: 'ABL1 相关融合',
                        },
                        {
                            value: 'tall_myb',
                            label: 'MYB 相关融合',
                        },
                        {
                            value: 'tall_tcr',
                            label: 'TCR 相关融合',
                        },
                    ]
                },
                {
                    value: 'mutation',
                    label: 'mutation',
                    children: [
                        {
                            value: 'tall_notch1',
                            label: 'NOTCH1',
                        },
                        {
                            value: 'tall_fbxw7',
                            label: 'FBXW7',
                        },
                        {
                            value: 'tall_phf6',
                            label: 'PHF6',
                        },
                        {
                            value: 'tall_jak1',
                            label: 'JAK1',
                        },
                        {
                            value: 'tall_jak3',
                            label: 'JAK3',
                        },
                        {
                            value: 'tall_pten',
                            label: 'PTEN',
                        },
                        {
                            value: 'tall_nras',
                            label: 'NRAS',
                        },
                        {
                            value: 'tall_kras',
                            label: 'KRAS',
                        },
                        {
                            value: 'tall_usp7',
                            label: 'USP7',
                        },
                        {
                            value: 'tall_gata3',
                            label: 'GATA3',
                        },
                        {
                            value: 'tall_rpl10',
                            label: 'RPL10',
                        },
                    ]
                },
                {
                    value: 'dysregulation',
                    label: 'dysregulation',
                    children: [
                        {
                            value: 'tall_tal1_high',
                            label: 'TAL1 高表达',
                        },
                        {
                            value: 'tall_tal2_high',
                            label: 'TAL2 高表达',
                        },
                        {
                            value: 'tall_tlx1_high',
                            label: 'TLX1 高表达',
                        },
                        {
                            value: 'tall_tlx3_high',
                            label: 'TLX3 高表达',
                        },
                        {
                            value: 'tall_hoxa_high',
                            label: 'HOXA家族 高表达',
                        },
                        {
                            value: 'tall_spi1_high',
                            label: 'SPI1 高表达',
                        },
                        {
                            value: 'tall_lmo1_high',
                            label: 'LMO1 高表达',
                        },
                        {
                            value: 'tall_lmo2_high',
                            label: 'LMO2 高表达',
                        },
                        {
                            value: 'tall_nkx21_high',
                            label: 'NKX2-1 高表达',
                        },
                        {
                            value: 'tall_lyl1_high',
                            label: 'LYL1 高表达',
                        },
                        {
                            value: 'tall_mef2c_high',
                            label: 'MEF2C 高表达',
                        },
                    ]
                },
            ]
    },
]

export const al_subtype_raw = [
    {
        value: '急性髓细胞白血病，微分化形（M0）',
        label: '急性髓细胞白血病，微分化形（M0）'
    },
    {
        value: '急性髓细胞白血病，未分化型（M1）',
        label: '急性髓细胞白血病，未分化型（M1）'
    },
    {
        value: '急性髓细胞白血病，部分分化型（M2）M2a',
        label: '急性髓细胞白血病，部分分化型（M2）M2a'
    },
    {
        value: '急性髓细胞白血病，部分分化型（M2）M2b',
        label: '急性髓细胞白血病，部分分化型（M2）M2b'
    },
    {
        value: '急性早幼粒细胞白血病（M3）',
        label: '急性早幼粒细胞白血病（M3）'
    },
    {
        value: '急性粒单细胞白血病（M4）M4a',
        label: '急性粒单细胞白血病（M4）M4a'
    },
    {
        value: '急性粒单细胞白血病（M4）M4b',
        label: '急性粒单细胞白血病（M4）M4b'
    },
    {
        value: '急性粒单细胞白血病（M4）M4eo',
        label: '急性粒单细胞白血病（M4）M4eo'
    },
    {
        value: '急性粒单细胞白血病（M4）M4未分类',
        label: '急性粒单细胞白血病（M4）M4未分类'
    },
    {
        value: '急性单核细胞白血病（M5）M5a',
        label: '急性单核细胞白血病（M5）M5a'
    },
    {
        value: '急性单核细胞白血病（M5）M5b',
        label: '急性单核细胞白血病（M5）M5b'
    },
    {
        value: '急性粒单细胞白血病（M5）M5未分类',
        label: '急性粒单细胞白血病（M5）M5未分类'
    },
    {
        value: '急性红白血病（M6）',
        label: '急性红白血病（M6）'
    },
    {
        value: '急性巨核细胞性白血病（M7）',
        label: '急性巨核细胞性白血病（M7）'
    },
    {
        value: '髓细胞肉瘤',
        label: '髓细胞肉瘤'
    },
    {
        value: '不能分型的AML',
        label: '不能分型的AML'
    },
    {
        value: '急性淋巴细胞白血病，pro-B细胞ALL',
        label: '急性淋巴细胞白血病，pro-B细胞ALL'
    },
    {
        value: '急性淋巴细胞白血病，common-B细胞ALL',
        label: '急性淋巴细胞白血病，common-B细胞ALL'
    },
    {
        value: '急性淋巴细胞白血病，pre-B细胞ALL',
        label: '急性淋巴细胞白血病，pre-B细胞ALL'
    },
    {
        value: '急性淋巴细胞白血病，mature-B细胞ALL',
        label: '急性淋巴细胞白血病，mature-B细胞ALL'
    },
    {
        value: '急性淋巴细胞白血病，T-ALL',
        label: '急性淋巴细胞白血病，T-ALL'
    },
    {
        value: '不能分型的ALL',
        label: '不能分型的ALL'
    }
]

export const al_subtypeList =
    [
        {
            value: 'AML(non-M3)',
            label: 'AML(non-M3)',
            children: [
                {
                    value: 'AML/M0',
                    label: 'AML/M0'
                },
                {
                    value: 'AML/M1',
                    label: 'AML/M1'
                },
                {
                    value: 'AML/M2',
                    label: 'AML/M2'
                },
                {
                    value: 'AML/M4',
                    label: 'AML/M4'
                },
                {
                    value: 'AML/M5',
                    label: 'AML/M5'
                },
                {
                    value: 'AML/M6',
                    label: 'AML/M6'
                },
                {
                    value: 'AML/M7',
                    label: 'AML/M7'
                },
                {
                    value: 'AML/不能分型',
                    label: 'AML/不能分型'
                },
            ]
        },
        {
            value: 'APL(M3)',
            label: 'APL(M3)',
            children: [
                {
                    value: 'AML/M3',
                    label: 'AML/M3'
                }
            ]
        },
        {
            value: 'T-ALL',
            label: 'T-ALL',
            children: [
                {
                    value: 'T-ALL',
                    label: 'T-ALL'
                }
            ]
        },
        {
            value: 'B-ALL',
            label: 'B-ALL',
            children: [
                {
                    value: 'B-ALL/pro-B',
                    label: 'B-ALL/pro-B'
                },
                {
                    value: 'B-ALL/common-',
                    label: 'B-ALL/common-3'
                },
                {
                    value: 'B-ALL/pre-B',
                    label: 'B-ALL/pre-B'
                },
                {
                    value: 'B-ALL/mature-B',
                    label: 'B-ALL/mature-B'
                }
            ]
        },
        {
            value: 'other',
            label: 'other',
            children: [
                {
                    value: 'ALL,不能分型',
                    label: 'ALL,不能分型'
                },
                {
                    value: '急性双表型白血病',
                    label: '急性双表型白血病'
                },
                {
                    value: '不详',
                    label: '不详'
                },
                {
                    value: '髓细胞肉瘤',
                    label: '髓细胞肉瘤'
                }
            ]
        }

    ]
